<template>
  <div class="miami">
    <ScrollupSection />
    <div class="all-area">
      <HeaderSection />
      <HeroSection />
      <PromoSection />
      <AboutSection />
      <NewsletterSection />
      <PricingSection />
      <FaqSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/Scrollup/Scrollup'
import HeaderSection from '../components/Header/HeaderOne'
import HeroSection from '../components/Hero/HeroOne'
import PromoSection from '../components/Promo/PromoOne'
import AboutSection from '../components/About/About'
import PricingSection from '../components/Pricing/Pricing'
import NewsletterSection from '../components/Newsletter/Newsletter'
import FaqSection from '../components/Faq/Faq'
import FooterSection from '../components/Footer/Footer'

export default {
  name: 'ThemeOne',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    PromoSection,
    AboutSection,
    PricingSection,
    NewsletterSection,
    FaqSection,
    FooterSection
  }
}
</script>

<style>

</style>